import { datadogRum } from '@datadog/browser-rum';
import React, { FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { RocketDocument32 } from 'components/atoms/icons';
import { logger } from 'services';

interface Props {
  loadingMessage: string;
  isEditorIntialisedOnce: boolean;
  setState: (state) => void;
}

const Content = styled.div`
  position: absolute;
  top: var(--spacing-08);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: var(--zindex-layer-02);
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

const Overlay = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--white-100);
  opacity: 0.95;
  z-index: var(--zindex-layer-01);
`;

const Icon = styled(RocketDocument32)`
  margin-bottom: var(--spacing-04);
  color: var(--blue-60);
`;

export const DocLoader: FC<Props> = ({
  loadingMessage = '',
  setState,
  isEditorIntialisedOnce,
}) => {
  useEffect(() => {
    const tagName = 'spaces-load-time';
    let isLoaded = true;
    const currentUrl = window.location.pathname;

    performance.mark(tagName);
    const intervalIds: number[] = [];

    for (let i = 1; i < 5; i += 1) {
      intervalIds.push(
        // eslint-disable-next-line @typescript-eslint/no-loop-func
        window.setTimeout(() => {
          if (i === 4) {
            isLoaded = false;
          }
          if (!isEditorIntialisedOnce) {
            logger.error(`Doc didn't load till ${i * 10} sec`, {
              error: `Doc didn't load till ${i * 10} sec`,
            });
          }
        }, i * 10_000),
      );
    }

    return () => {
      try {
        const loadTime = performance.measure(tagName, tagName);
        const isSameTabName = window.location.pathname === currentUrl;

        if (isLoaded && isSameTabName) {
          logger.log('loaded at', loadTime.duration);
          datadogRum.addTiming(tagName, loadTime.duration);
        }

        performance.clearMarks(tagName);
        performance.clearMeasures(tagName);
        intervalIds.map((id) => clearTimeout(id));
        setState({ isInitialisedOnce: true });
        // eslint-disable-next-line no-empty
      } catch (e) {}
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrapper>
      <Overlay />
      <Content>
        <Icon />
        <FormattedMessage id={loadingMessage} />
      </Content>
    </Wrapper>
  );
};
